export default "__VITE_ASSET__5FjIZhLm__"